import React from 'react'
import {MdStar, MdStarBorder} from 'react-icons/md'
import range from 'lodash/range'
import {useRouter} from 'next/router'
import {useTranslation} from 'next-i18next'

import styles from './styles.module.css'

export default function Review(props) {
  const {order} = props
  const router = useRouter()
  const {review} = order
  const {t} = useTranslation('website', {keyPrefix: 'orders.order.review'})

  if (!review || !review.rating) {
    return (
      <div
        onClick={() => setTimeout(() => router.replace(`/review/${order._id}`), 1)}
        className={styles.link}>
        {t('labelRate')}
      </div>
    )
  }

  return (
    <div className={styles.stars}>
      {range(1, 6).map(index => (
        <div className={styles.star} key={index}>
          {review.rating >= index ? <MdStar size={18} /> : <MdStarBorder size={18} />}
        </div>
      ))}
    </div>
  )
}
